import { Flex, Image, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import { useGetState } from "../../../../context/useGetState";
import { photoBaseURL } from "../../../../service/api";
import { trunc } from "../../../../utils";

function StoriesCard({ story }) {
  const textColor1 = useColorModeValue("#444D6E", "#fff");
  const { state } = useGetState();

  const getFirstStory = story?.stories?.[0];

  return story?.stories?.length > 0 ? (
    <Stack>
      <Stack position={"relative"}>
        <Flex
          w="60px"
          h="60px"
          maxW="60px"
          maxH={"60px"}
          objectFit={"cover"}
          borderRadius={"20px"}
          bg={getFirstStory?.content?.background}
          justify="center"
          align="center"
        >
          {getFirstStory?.type === "video" ? (
            <video
              loop
              width="100%"
              controls
              style={{ borderRadius: "20px", height: "100%" }}
            >
              <source
                src={`${photoBaseURL}${story?.content}`}
                type={getFirstStory?.type}
              />
              Your browser does not support HTML5 video.
            </video>
          ) : getFirstStory?.type === "image" ? (
            <Image
              w="60px"
              h="60px"
              objectFit={"cover !important"}
              borderRadius={"20px"}
              src={`${getFirstStory?.content?.file}`}
            />
          ) : (
            <Text
              fontSize={"8px"}
              textAlign={"center"}
              lineHeight="1"
              color={getFirstStory?.content?.color}
              fontWeight="bold"
            >
              {trunc(getFirstStory?.content?.text, 20)}
            </Text>
          )}
        </Flex>

        <Stack position={"absolute"} bottom={"-10px"} left="15px">
          <Image
            borderRadius={"50%"}
            w="30px"
            h="30px"
            size={"xs"}
            name={state?.userInfo?.username}
            objectFit={"cover !important"}
            src={`${state?.userInfo?.picture}`}
            alt="story pic"
          />
        </Stack>
      </Stack>
      <Text color={textColor1} textAlign="center" fontSize={".7em"}>
        Your stories
      </Text>
    </Stack>
  ) : (
    ""
  );
}

export default StoriesCard;
